(function(){
  if (window.__rbInit) return;
  window.__rbInit = true;
  function wrapText(){
    document.querySelectorAll(".rb-btn").forEach(function(b){
      Array.prototype.slice.call(b.childNodes).forEach(function(n){
        if (n.nodeType === 3 && n.textContent.trim()){
          var s = document.createElement("span");
          s.className = "bt";
          b.replaceChild(s, n);
          s.appendChild(n);
        }
      });
    });
  }
  var NS = "http://www.w3.org/2000/svg";
  function attach(el){
    if (el.__rbTron) return;
    el.__rbTron = true;
    var pad = 8, r = 2;
    var svg = document.createElementNS(NS, "svg");
    svg.setAttribute("class", "rb-tron");
    var paths = [];
    ["glowA", "glowB", "core"].forEach(function(cls){
      var p = document.createElementNS(NS, "path");
      p.setAttribute("class", cls);
      svg.appendChild(p);
      paths.push(p);
    });
    el.insertBefore(svg, el.firstChild);
    var Q = 0, t = 0, raf = null;
    function setDash(tt){
      var g = Q * tt;
      var da = "0 " + Math.max(0, Q - g) + " " + (2*g) + " " + Math.max(0, 2*Q - 2*g) + " " + (2*g) + " " + Math.max(0, Q - g);
      paths.forEach(function(p){ p.setAttribute("stroke-dasharray", da); });
    }
    function geom(){
      var w = el.offsetWidth, h = el.offsetHeight;
      if (w < 20 || h < 10) return;
      svg.setAttribute("width", w + pad*2);
      svg.setAttribute("height", h + pad*2);
      var x0 = pad, y0 = pad, x1 = pad + w, y1 = pad + h, xm = pad + w/2;
      var d = "M " + xm + " " + y0 +
        " L " + (x1-r) + " " + y0 + " A " + r + " " + r + " 0 0 1 " + x1 + " " + (y0+r) +
        " L " + x1 + " " + (y1-r) + " A " + r + " " + r + " 0 0 1 " + (x1-r) + " " + y1 +
        " L " + (x0+r) + " " + y1 + " A " + r + " " + r + " 0 0 1 " + x0 + " " + (y1-r) +
        " L " + x0 + " " + (y0+r) + " A " + r + " " + r + " 0 0 1 " + (x0+r) + " " + y0 +
        " L " + xm + " " + y0;
      paths.forEach(function(p){ p.setAttribute("d", d); });
      Q = paths[2].getTotalLength() / 4;
      setDash(t);
    }
    geom();
    if (window.ResizeObserver) new ResizeObserver(geom).observe(el);
    function animTo(target){
      if (raf) cancelAnimationFrame(raf);
      var from = t, start = performance.now(), dur = 520;
      function step(now){
        var pr = Math.min(1, (now - start) / dur);
        pr = pr < .5 ? 2*pr*pr : 1 - Math.pow(-2*pr + 2, 2) / 2;
        t = from + (target - from) * pr;
        setDash(t);
        if (pr < 1) raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }
    el.addEventListener("pointerenter", function(){ animTo(1); });
    el.addEventListener("pointerleave", function(){ animTo(0); });
  }
  function timers(){
    var els = document.querySelectorAll("[data-rb-timer]");
    if (!els.length) return;
    function tick(){
      els.forEach(function(e){
        var end = new Date(e.getAttribute("data-rb-timer")).getTime();
        if (isNaN(end)){ e.textContent = ""; return; }
        var ms = end - Date.now();
        if (ms <= 0){ e.textContent = "Promotion ended"; return; }
        var d = Math.floor(ms/864e5), h = Math.floor(ms%864e5/36e5), m = Math.floor(ms%36e5/6e4);
        e.textContent = "Ends in " + d + "d " + String(h).padStart(2,"0") + "h " + String(m).padStart(2,"0") + "m";
      });
      setTimeout(tick, 30000);
    }
    tick();
  }
  function init(){
    wrapText();
    document.querySelectorAll(".rb-btn, .rbh .megain.listin a, .rbh .bpin a").forEach(attach);
    timers();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

(function(){
  if (window.__rbhInit) return;
  window.__rbhInit = true;
  function init(){
    var h = document.querySelector(".rbh");
    if (!h) return;
    var hero = document.querySelector(".rb-hero, .rb-panel, .rb-pcrumb, .rbp .phero, .rbp .c-hero, .rbp .c-hero2, .rbp .whero, .rbp .srhero, .rbp .gal-head");
    var transOK = false;
    if (hero){
      var r = hero.getBoundingClientRect();
      transOK = (r.top + (window.scrollY || 0)) < 300;
    }
    if (!transOK){
      h.classList.remove("attop");
      document.body.style.paddingTop = h.offsetHeight + "px";
    }
    var last = window.scrollY || 0;
    function upd(){
      var y = window.scrollY || 0;
      if (Math.abs(y - last) > 2){
        document.querySelectorAll(".rbh .hasmega.open, .rbh .bp.open").forEach(function(x){ x.classList.remove("open"); });
      }
      if (y <= 60){
        if (transOK) h.classList.add("attop");
        h.classList.remove("hid");
      } else {
        h.classList.remove("attop");
        if (y > last + 2 && !h.classList.contains("mopen")) h.classList.add("hid");
        else if (y < last - 2) h.classList.remove("hid");
      }
      last = y;
    }
    window.addEventListener("scroll", upd, {passive: true});
    upd();
    document.querySelectorAll(".rbh .hasmega, .rbh .bp").forEach(function(it){
      var trig = it.querySelector("button.top, a.rb-btn");
      it.addEventListener("pointerenter", function(e){ if (e.pointerType === "mouse"){
        document.querySelectorAll(".rbh .hasmega.open, .rbh .bp.open").forEach(function(x){ if (x !== it) x.classList.remove("open"); });
        setM(false);
        it.classList.add("open");
      } });
      it.addEventListener("pointerleave", function(e){ if (e.pointerType === "mouse") it.classList.remove("open"); });
      if (trig) trig.addEventListener("click", function(e){
        var touch = window.matchMedia("(hover: none)").matches;
        if (trig.tagName === "BUTTON" || (touch && !it.classList.contains("open"))){
          e.preventDefault();
          document.querySelectorAll(".rbh .hasmega.open, .rbh .bp.open").forEach(function(x){ if (x !== it) x.classList.remove("open"); });
          if (!it.classList.contains("open")) setM(false);
          it.classList.toggle("open");
        }
      });
    });
    function setM(state){
      h.classList.toggle("mopen", state);
      document.body.style.overflow = state ? "hidden" : "";
    }
    var burger = document.querySelector(".rbh .burger");
    if (burger) burger.addEventListener("click", function(){
      document.querySelectorAll(".rbh .hasmega.open, .rbh .bp.open").forEach(function(x){ x.classList.remove("open"); });
      setM(!h.classList.contains("mopen"));
    });
    document.querySelectorAll(".rbh .mob .mgrp > button.mgt").forEach(function(b){
      b.addEventListener("click", function(){ b.parentElement.classList.toggle("open"); });
    });
    document.addEventListener("click", function(e){
      if (h.classList.contains("mopen") && !h.contains(e.target)) setM(false);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
